module.exports = {
    login:'登入',
    taption: 'Taption',
    ways_to_use_taption:'簡單教學',
    faq:'常見問題',
    pricing:'價格',
    language:'語言',
    product:'產品介紹'
  }
  